import { useEffect, useState } from 'react'
import { api } from './api'
import { beschriftung, t } from './sprache'
import type { Sprachschluessel } from './sprache'
import type { Listeneintrag } from './typen'

/**
 * **Die vier Abschnitte der Kapitalflussrechnung, mit ihrer Nummer und ihrem
 * Namen** (2.8 Abschnitt 13.41, R1333) — je Zeilensatz gepflegt, per
 * Rechtsklick auf das Band.
 *
 * **Ersatz, solange sie nicht da sind**: die Namen ab Werk aus den Texten der
 * Oberfläche. Ein Band ohne Namen sähe aus wie ein Fehler in der Rechnung.
 */
export type Kfrabschnitt = { schluessel: string; titel: string }

/** Die Abschnitte als Liste, neu geholt, sooft `stand` sich ändert. */
export function useKfrabschnitte(stand: number): Listeneintrag[] {
  const [liste, setListe] = useState<Listeneintrag[]>([])

  useEffect(() => {
    let gilt = true
    // Ohne den Abruf (in einem Prüffall ohne Server) bleibt es beim Ersatz.
    const abruf = typeof api.stammdatenliste === 'function' ? api.stammdatenliste('kfr_abschnitt') : null
    abruf
      ?.then((l) => {
        if (gilt) setListe(l.eintraege)
      })
      .catch(() => {
        // Ersatz: die Namen ab Werk.
      })
    return () => {
      gilt = false
    }
  }, [stand])

  return liste
}

/** Nummer und Name eines Abschnitts in einem Zeilensatz — oder der Ersatz ab Werk. */
export function abschnitt(liste: Listeneintrag[], standard: string | null | undefined, bereich: string): Kfrabschnitt | null {
  const eintrag = liste.find((e) => e.werte['standard'] === standard && e.werte['bereich'] === bereich)
  if (!eintrag) {
    return null
  }
  const name = beschriftung(eintrag.namen)
  return { schluessel: eintrag.schluessel, titel: [eintrag.code ? `${eintrag.code}.` : '', name].filter(Boolean).join(' ') }
}

/** Was auf dem Band steht. */
export function abschnittstitel(liste: Listeneintrag[], standard: string | null | undefined, bereich: string): string {
  return abschnitt(liste, standard, bereich)?.titel ?? t(`kfr.bereich.${bereich}` as Sprachschluessel)
}
